module.exports = __webpack_public_path__ + "static/media/BlueBulb.9978fa53.svg";